<template>
  <q-btn-group v-bind="$attrs">
    <media-filter-btn
      icon="fa fa-image"
      title="Images"
      :types="['image']"
      :model-value="modelValue"
      class="q-py-sm"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
    <media-filter-btn
      title="Videos"
      icon="fa fa-video"
      :types="['video', 'embed']"
      :model-value="modelValue"
      class="q-py-sm"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
    <q-btn
      v-if="modelValue.length"
      icon="fa fa-times"
      class="q-py-sm"
      @click="$emit('update:modelValue', [])"
    />
  </q-btn-group>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { QBtnGroup } from 'quasar';
import MediaFilterBtn from './MediaFilterBtn.vue';

export default defineComponent({
  emits: ['update:modelValue'],
  components: { QBtnGroup, MediaFilterBtn },
  props: {
    modelValue: {
      type: Array as () => string[],
      default: () => [],
    },
  },
});
</script>
